import { render, staticRenderFns } from "./PrivateAd.vue?vue&type=template&id=3186d3c6&scoped=true&"
import script from "./PrivateAd.vue?vue&type=script&lang=js&"
export * from "./PrivateAd.vue?vue&type=script&lang=js&"
import style0 from "./PrivateAd.vue?vue&type=style&index=0&id=3186d3c6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3186d3c6",
  null
  
)

export default component.exports